/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Bidder = {

	getAutocomplete (context, query, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/autocomplete"
			+ "?query=" + query
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderData (context, bidderId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/bidder-data"
			+ "?bidderId=" + bidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderExist (context, token, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/bidder-exist"
			+ "?token=" + token
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderLegalForm (context, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/bidder-legal-form"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getBidderPolishOrganizationNames (context, notificationGroupId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/bidder-polish-organization-names"
			+ "?notificationGroupId=" + notificationGroupId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDetails (context, id, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/details"
			+ "?id=" + id
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getLegalForm (context, mainBidderId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/legal-form"
			+ "?mainBidderId=" + mainBidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferBiddersOriginalData (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/offer-bidders-original-data"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOriginalOfferDetails (context, bidderId, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/original-offer-details"
			+ "?bidderId=" + bidderId
			+ "&offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOriginalOfferVersionDetails (context, bidderId, offerId, version, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/original-offer-version-details"
			+ "?bidderId=" + bidderId
			+ "&offerId=" + offerId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOriginalProjectDetails (context, bidderId, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/original-project-details"
			+ "?bidderId=" + bidderId
			+ "&projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOriginalProjectVersionDetails (context, bidderId, projectId, version, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/original-project-version-details"
			+ "?bidderId=" + bidderId
			+ "&projectId=" + projectId
			+ "&version=" + version
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPolishName (context, id, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/polish-name"
			+ "?id=" + id
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubBidderData (context, subBidderId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/sub-bidder-data"
			+ "?subBidderId=" + subBidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubBidderPolishOrganizationNames (context, notificationGroupId, onSuccess, onError, options) {
		Api.get(context,
			"/bidder/sub-bidder-polish-organization-names"
			+ "?notificationGroupId=" + notificationGroupId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, registerBidderRequest, onSuccess, onError, options) {
		Api.post(context,
			"/bidder"
			, registerBidderRequest
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postChangeBidderEmail (context, userEmailDTO, onSuccess, onError, options) {
		Api.post(context,
			"/bidder/change-bidder-email"
			, userEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSetupNewEmailAddress (context, setupEmailDTO, onSuccess, onError, options) {
		Api.post(context,
			"/bidder/setup-new-email-address"
			, setupEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putOfferBidderOriginalData (context, offerId, bidderId, bidderEditOriginalDataDTO, onSuccess, onError, options) {
		Api.put(context,
			"/bidder/offer-bidder-original-data"
			+ "?offerId=" + offerId
			+ "&bidderId=" + bidderId
			, bidderEditOriginalDataDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
